import React from 'react'
import Home from './Home'
import Whatweoffer from '../components/Whatweoffer'
import About from '../components/About'
import Explorelist from '../components/Explorelist'
import LookingFor from '../components/LookingFor'
import Info from '../components/Info'
import Quickform from '../components/Quickform'
import Downlist from '../components/Downlist'

const Homepage = () => {
  return (
    <div>
    <Home/>
     <Whatweoffer/>
     <About/>
     <Explorelist/>
     <LookingFor/>
     <Info/>
     <Quickform/>
     <Downlist/>
    </div>
  )
}

export default Homepage